<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <Sideleft
      :sideStatus="leftSideStatus"
      :key-name="filterProp.keyName"
      :key-status="filterProp.keyStatus"
      :list="roleList"
      :key-role-id="filterProp.keyRoleId"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :checkArr="checkArr"
        :key-name="filterProp.keyName"
        :key-status="filterProp.keyStatus"
        :key-role-id="filterProp.keyRoleId"
        :key-role-name="filterProp.keyRoleName"
      ></Header>
      <!-- 中间内容 -->
      <div class="br-pagebody pd-x-20 pd-sm-x-30">
        <!-- 提示子账号登录的地址 -->
        <div
          v-if="subuserId == '0' && subuserList.length > 0"
          class="card mg-b-20 pd-20 card-subuser"
        >
          <p class="tx-gray-300 tx-16">
            {{ $t("subuser.欢迎启用子账号帮助管理您的业务") }}
          </p>
          <p v-if="!userInfo.rootUrl" class="mg-b-0">
            <span class="tx-gray-300">{{
              $t("subuser.您的子账号登录链接：")
            }}</span>
            <span class="tx-info mg-r-10"> {{ subLoginUrl }}</span>
            <a
              class="btn btn-sm btn-info to-clipboard"
              href="javascript:;"
              :data-clipboard-text="subLoginUrl"
            >
              {{ $t("subuser.复制链接") }}
            </a>
          </p>
        </div>
        <router-view
          v-if="isSysRights('SubUser.findByUser')"
          :first_loading="firstLoading"
          :items="subuserList"
          :check_arr="checkArr"
          @relationship="openRelationship"
        >
        </router-view>
        <no-rights v-else></no-rights>
      </div>
    </div>
    <!-- 新建或修改角色信息 -->
    <modalSubUserGroup
      v-if="
        isSysRights('UserRole.addUserRole') ||
        isSysRights('UserRole.changeUserRole')
      "
      :open="roleinfo.open"
      :info="roleinfo.info"
    ></modalSubUserGroup>
    <!-- 删除角色信息 -->
    <modalSubUserDelGroup
      v-if="isSysRights('UserRole.delUserRole')"
      :id.sync="roleinfo.id"
      :del_name.sync="roleinfo.name"
    ></modalSubUserDelGroup>
    <!-- 批量加入角色组 -->
    <modalBatchRoleGroup :list="roleList"></modalBatchRoleGroup>
    <!-- 新增或修改子账号信息 -->
    <modalEditSubuser
      v-if="
        isSysRights('SubUser.insertByUser') ||
        isSysRights('SubUser.changeByUser')
      "
      :item="subUserinfo"
      :role-list="roleList"
    ></modalEditSubuser>
    <!-- 删除子账号 -->
    <delSubUser
      v-if="isSysRights('SubUser.deleteByUser')"
      :del_name="subUserinfo.delName"
      :id="subUserinfo.delId"
    ></delSubUser>
    <!-- 绑定微信号 -->
    <bindWx
      :user_id="userId"
      :sub_user_id="subUserinfo.subuserId"
      :open="subUserinfo.open"
    ></bindWx>
    <!-- 解除微信绑定 -->
    <unbindWx
      v-if="isSysRights('SubUser.unbindWx')"
      :item="subUserinfo"
    ></unbindWx>
    <Modal
      :modalId="'modalRelationshipD'"
      :home="false"
      :loading="modalRelationshipD.loading"
      :size="'lg'"
      :autoH="true"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("subuser.关联客户：") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="row mg-b-15 align-items-center">
            <div class="col-3">
              <SelectDistributor
                :key_word="modalRelationshipD.keyDistributorName"
                @changeKeyword="changeName"
                @keywordEnter="filtrateName"
              />
            </div>
            <div class="col-3">
              <a
                class="btn btn-primary btn-sm"
                href="javascript:;"
                @click="modalGoto(1)"
              >
                {{ $t("subuser.查询") }}
              </a>
            </div>
          </div>
          <table v-if="modalRelationshipD.dList.length" class="table mg-b-15">
            <thead>
              <tr>
                <th class="wd-10p">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :checked="AllCheck"
                      @change="changeAllCheck($event)"
                    />
                    <span>{{ $t("subuser.全选") }}</span>
                  </label>
                </th>
                <th class="tx-10-force wd-lg-250 tx-mont tx-medium">
                  {{ $t("subuser.客户") }}
                </th>
                <th class="tx-10-force wd-lg-250 tx-mont tx-medium">
                  {{ $t("subuser.联系人") }}
                </th>
                <th class="tx-10-force wd-lg-250 tx-mont tx-medium">
                  {{ $t("subuser.结算方式/周期") }}
                </th>
                <th class="tx-10-force wd-lg-250 tx-mont tx-medium">
                  {{ $t("subuser.已关联账号") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dItem in modalRelationshipD.dList" :key="dItem.id">
                <td class="valign-middle">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="dItem.id"
                      v-model="modalRelationshipD.sList"
                    /><span></span>
                  </label>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div
                      class="text-user-icon mg-r-15"
                      :style="{ background: textColor(dItem.name) }"
                    >
                      {{ (dItem.name || "").substr(0, 1).toUpperCase() }}
                    </div>
                    <div>
                      {{ dItem.name }}
                    </div>
                  </div>
                </td>
                <td class="valign-middle">
                  {{ dItem.contact }}
                </td>
                <td class="valign-middle">
                  {{ $t(modalRelationshipD.dStatus[dItem.settleMethod]) }}
                </td>
                <td class="valign-middle">
                  <div
                    v-if="
                      dItem.supplierSubUser.order &&
                      dItem.supplierSubUser.order.length
                    "
                  >
                    <div
                      v-for="order in dItem.supplierSubUser.order"
                      :key="order.id"
                    >
                      <span class="mg-r-5">{{ order.name }}</span>
                      <a
                        class="tx-danger"
                        href="javascript:;"
                        @click="removeSubUser(dItem, order.id)"
                        >{{ $t("subuser.解除") }}</a
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="nodata mg-t-50 mg-b-50 text-center tx-24">
            <i class="menu-item-icon icon ion-person tx-24"></i>
            {{ $t("subuser.没有符合条件的客户") }}
          </div>
          <div
            v-if="modalRelationshipD.dList.length > 0"
            class="
              inner-pagination
              ht-80
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <nav aria-label="Page navigation">
              <ul class="pagination pagination-basic mg-b-0">
                <li v-if="showFirst" class="page-item" @click="modalGoto(1)">
                  <a href="javascript:;" class="page-link"
                    ><i class="fa fa-angle-double-left"></i
                  ></a>
                </li>
                <li
                  v-if="showFirst"
                  class="page-item"
                  @click="modalGoto(parseInt(modalRelationshipD.page) - 1)"
                >
                  <a
                    href="javascript:;"
                    class="page-link wd-60"
                    style="white-space: nowrap; width: auto !important"
                    >{{ $t("subuser.前一页") }}</a
                  >
                </li>
                <li
                  v-for="index in indexs"
                  :key="index"
                  class="page-item"
                  :class="{ active: modalRelationshipD.page == index }"
                  @click="modalGoto(index)"
                >
                  <a href="javascript:;" class="page-link">{{ index }}</a>
                </li>
                <li
                  v-if="showLast"
                  class="page-item"
                  @click="modalGoto(parseInt(modalRelationshipD.page) + 1)"
                >
                  <a href="javascript:;" class="page-link wd-60">{{
                    $t("subuser.后一页")
                  }}</a>
                </li>
                <li
                  v-if="showLast"
                  class="page-item"
                  @click="modalGoto(modalRelationshipD.totalPage)"
                >
                  <a href="javascript:;" class="page-link"
                    ><i class="fa fa-angle-double-right"></i
                  ></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-between
              pd-x-25
              mg-b-0
            "
          >
            <div>
              {{ $t("subuser.选中") }}
              <span class="tx-bold tx-primary">{{
                modalRelationshipD.sList.length
              }}</span>
              {{ $t("subuser.家客户，") }} {{ $t("subuser.关联到") }}
              <span class="tx-primary">{{ modalRelationshipD.name }}</span>
            </div>
            <div>
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveRelationshipD"
              >
                {{ $t("subuser.设为关联") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("subuser.取消") }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Sideleft from "./left-side.vue";
import Header from "./header.vue";
import modalSubUserGroup from "./modal-subuser-group.vue";
import modalSubUserDelGroup from "./modal-del-subuser-group.vue";
import modalBatchRoleGroup from "./modal-batch-role-group";
import modalEditSubuser from "./modal-edit-subuser.vue";
import delSubUser from "./del-subuser.vue";
import bindWx from "./bind-wx-subuser.vue";
import unbindWx from "./unbind-wx-subuser.vue";
import Modal from "@components/Modal";
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索

export default {
  components: {
    Sideleft,
    Header,
    modalSubUserGroup,
    modalSubUserDelGroup,
    modalBatchRoleGroup,
    modalEditSubuser,
    delSubUser,
    bindWx,
    unbindWx,
    Modal,
    SelectDistributor,
  },
  data() {
    return {
      firstLoading: false,
      loading: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      // 搜索条件
      filterProp: {
        keyName: "",
        keyStatus: "",
        keyRoleId: "",
        keyRoleName: "",
      },
      // 角色列表
      roleList: [],
      // 角色信息
      roleinfo: {},
      // 子账号id
      subuserId: localStorage.getItem("apiSubUserId"),
      // 子账号列表
      subuserList: [],
      // 用户信息
      userInfo: store.get("userInfo"),
      // 用户id
      userId: localStorage.getItem("apiUserId"),
      // 子账号信息
      subUserinfo: {},
      // 选中的子账号id数组
      checkArr: [],
      modalRelationshipD: {
        loading: false,
        dStatus: arrDict.settleMethodStatus,
        page: 1,
        rowsPerPage: 5,
        totalCount: 0,
        totalPage: 1,
        dList: [], //经销商列表
        sList: [], //已选择
        name: "",
        sid: "",
        keyDistributorName: "",
        keyDistributorId: "",
      },
      modalRelationshipDDefault: "{}",
    };
  },
  computed: {
    subLoginUrl() {
      return `https://${document.domain}/#/${this.userInfo.id}/${this.userInfo.username}`;
    },
    AllCheck() {
      if (!this.modalRelationshipD.dList.length) {
        return false;
      }
      let num = 0;
      this.modalRelationshipD.dList.forEach((e) => {
        if (this.modalRelationshipD.sList.indexOf(e.id) > -1) {
          num++;
        }
      });
      if (num == this.modalRelationshipD.dList.length) {
        return true;
      } else {
        return false;
      }
    },
    indexs: function () {
      let ar = [];
      let left, right;
      if (this.modalRelationshipD.page < 5) {
        for (let i = 1; i < 8; i++) {
          ar.push(i);
          if (i >= this.modalRelationshipD.totalPage) break;
        }
      } else {
        left = right = this.modalRelationshipD.page;
        for (let i = 0; i < 4; i++) {
          ar.unshift(left--);
          if (left <= 1) break;
        }
        for (let i = 0; i < 3; i++) {
          if (right >= this.modalRelationshipD.totalPage) break;
          right++;
          ar.push(right);
        }
      }
      return ar;
    },
    showLast: function () {
      if (this.modalRelationshipD.page == this.modalRelationshipD.totalPage) {
        return false;
      }
      return true;
    },
    showLastPer: function () {
      if (
        this.modalRelationshipD.totalPage - this.modalRelationshipD.page <
        10
      ) {
        return false;
      }
      return true;
    },
    showFirst: function () {
      if (this.modalRelationshipD.page == 1) {
        return false;
      }
      return true;
    },
    showFirstPer: function () {
      if (this.modalRelationshipD.page < 11) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    // 获取子账号列表
    this.getSubuserList();
    // 获取角色列表
    this.getRoleList();
    this.modalRelationshipDDefault = JSON.stringify(this.modalRelationshipD);
  },
  methods: {
    // 获取角色列表
    getRoleList() {
      if (!this.isSysRights("UserRole.findByUserId")) return;
      let getData = (data) => {
        this.roleList = data;
      };
      $.api_call("api.UserRole.findByUserId", {}, (r) => {
        if (r.ErrorCode == "9999") {
          getData(r.Data.Results);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    // 获取子账号列表
    getSubuserList() {
      if (!this.isSysRights("SubUser.findByUser")) return false;
      this.loading = true;
      let getData = (data) => {
        this.subuserList = [];
        data.Results.forEach((e) => {
          if (e.wxInfoJson) {
            e.headImg = JSON.parse(e.wxInfoJson).headimgurl;
          } else {
            e.headImg = "";
          }
          this.subuserList.push(e);
        });
      };
      $.api_call(
        "api.SubUser.findByUser",
        {
          nameLike: this.filterProp.keyName,
          roleId: this.filterProp.keyRoleId,
          status: this.filterProp.keyStatus,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            getData(r.Data);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeName(name, id) {
      this.modalRelationshipD.keyDistributorName = name;
      this.modalRelationshipD.keyDistributorId = id;
    },
    filtrateName(name, id) {
      if (!name) {
        this.modalRelationshipD.keyDistributorName = "";
        this.modalRelationshipD.keyDistributorId = "";
        this.modalGoto(1);
      }
      if (name && name == this.modalRelationshipD.keyDistributorName) {
        this.modalGoto(1);
        return;
      }
      if (!id || id == "e999") {
        if (id == "e999")
          ShowTip(this.$t("subuser.没有匹配的供应商"), "danger");
        this.modalRelationshipD.keyDistributorName = "";
        this.modalRelationshipD.keyDistributorId = "";
      } else {
        //清空按供应商名
        this.modalRelationshipD.keyDistributorName = name;
        this.modalRelationshipD.keyDistributorId = id;
      }
      this.modalGoto(1);
    },
    removeSubUser(item, id) {
      this.modalRelationshipD.loading = true;
      $.api_call(
        "api.Relationship.removeSupplierSubUserId",
        { relationshipIds: item.id, subUserId: id },
        (r) => {
          this.modalRelationshipD.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("subuser.解除关联成功"), "success");
            this.getDlist();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    modalGoto(index) {
      this.modalRelationshipD.page = index;
      this.modalRelationshipD.loading = false;
      $(".modal-body").scrollTop(0);
      this.getDlist();
    },
    textColor(txt) {
      return computColor(txt);
    },
    saveRelationshipD() {
      this.modalRelationshipD.loading = true;
      $.api_call(
        "api.Relationship.updateSupplierSubUserId",
        {
          relationshipIds: this.modalRelationshipD.sList.join(","),
          subUserId: this.modalRelationshipD.sid,
        },
        (r) => {
          this.modalRelationshipD.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("subuser.关联成功"), "success");
            this.getDlist();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeAllCheck(event) {
      this.modalRelationshipD.dList.forEach((e) => {
        if (event.target.checked) {
          // 全选
          this.modalRelationshipD.sList.push(e.id);
        } else {
          // 不选
          this.modalRelationshipD.sList.some((s, i) => {
            if (s == e.id) {
              this.modalRelationshipD.sList.splice(i, 1);
              return true;
            }
          });
        }
      });
    },
    getDlist() {
      this.modalRelationshipD.loading = true;
      $.api_call(
        "api.Distributor.findBySupplier",
        {
          page: this.modalRelationshipD.page,
          rowsPerPage: this.modalRelationshipD.rowsPerPage,
          distributorId: this.modalRelationshipD.keyDistributorId,
        },
        (r) => {
          this.modalRelationshipD.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalRelationshipD.totalCount = r.Data.Pagination.totalCount;
            this.modalRelationshipD.totalPage = r.Data.Pagination.totalPage;
            this.modalRelationshipD.dList = r.Data.Results;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openRelationship(item) {
      this.modalRelationshipD = JSON.parse(this.modalRelationshipDDefault);
      this.modalRelationshipD.name = item.name;
      this.modalRelationshipD.sid = item.id;
      this.getDlist();
      $("#modalRelationshipD").modal("show");
    },
  },
};
</script>

<style>
#modalRelationshipD .form-control-dark {
  background-color: #fff;
  border-color: #ddd;
  color: #333;
}
</style>